import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Route, Switch } from 'react-router-dom';

import UserList from './UserList';
import UserEdit from './UserEdit';

import styles from './styles.module.scss';

class OnTruckUsersContainer extends Component {
  render() {
    const { match } = this.props;

    return (
      <div className={styles.container}>
        <Route path={match.url} component={UserList} />
        <Switch>
          <Route path={`${match.url}/new`} component={UserEdit} />
          <Route path={`${match.url}/:id`} component={UserEdit} />
        </Switch>
      </div>
    );
  }
}

OnTruckUsersContainer.propTypes = {
  match: PropTypes.object.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OnTruckUsersContainer);
